import { Dialog, Image, PopupHeader } from '@pcln/horizon'

import CONTENT from '@/constants/content'

import type { ExpressDealDialogProps } from './ExpressDealDialog.types'
import HorizonFlightForm from './HorizonForm/HorizonFlightForm'
import { onSubmitExpressDeal } from './SearchForm/utils'

const EXPRESS_DEALS_LOGO_SRC =
  'https://s1.pclncdn.com/design-assets/brand-assets/express-deals-logo-registard.svg'

export function HorizonExpressDealDialog({ isOpen, closeDialog }: ExpressDealDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) closeDialog()
      }}
    >
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Popup size='md'>
          <div className='relative px-5 pt-5 pr-14'>
            <Image src={EXPRESS_DEALS_LOGO_SRC} isSvg height={6} className='w-[164px]' alt='Express Deals' />
            <Dialog.Close render={<PopupHeader.Close aria-label='Close Express Deals dialog' />} />
          </div>
          <Dialog.Title className='sr-only'>Flights Express Deal Dialog</Dialog.Title>
          <Dialog.Body slots={{ content: 'flex flex-col gap-4 px-5 pt-3 pb-5' }}>
            <Dialog.Description className='text-body2 text-neutral-13'>
              {CONTENT.homepage.flights.expressDeals.headline}
            </Dialog.Description>
            <HorizonFlightForm onSubmit={onSubmitExpressDeal} pageName='landing' isExpressDeal />
          </Dialog.Body>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
